<div class="modal-header">
    <a class="close" (click)="closeClick()">
      <span aria-hidden="true">×</span>
    </a>
</div>
<div class="modal-body">
  <app-time-slot-calendar (monthChanged)="dateSelected($event, false)" (dateSelected)="dateSelected($event, true)" [calendarService]="calendarService"></app-time-slot-calendar>
</div>
